import React, { useEffect, useState } from "react";
import { tradeGet, tradeJson } from "../../utils/tradeApi";

function CategoryRow({ category, busy, onSave, onDelete }) {
  const [name, setName] = useState(category.name || "");
  const [sortOrder, setSortOrder] = useState(category.sort_order ?? "");
  const [active, setActive] = useState(category.active !== false);

  useEffect(() => {
    setName(category.name || "");
    setSortOrder(category.sort_order ?? "");
    setActive(category.active !== false);
  }, [category]);

  return (
    <div className="trade-category-admin-row">
      <strong>{category.code}</strong>
      <label>Name<input value={name} onChange={(event) => setName(event.target.value)} /></label>
      <label>Order<input type="number" value={sortOrder} onChange={(event) => setSortOrder(event.target.value)} /></label>
      <label className="trade-check"><input type="checkbox" checked={active} onChange={(event) => setActive(event.target.checked)} />Active</label>
      <div className="trade-action-row">
        <button className="trade-button secondary" disabled={busy || !name.trim()} onClick={() => onSave(category._id, { name: name.trim(), sortOrder: Number(sortOrder), active })}>Save</button>
        <button className="trade-link-button danger" disabled={busy} onClick={() => onDelete(category)}>Delete</button>
      </div>
    </div>
  );
}

export default function TradeCategoryManager({ projectId, onClose, onChanged }) {
  const [categories, setCategories] = useState([]);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  async function load() {
    setCategories(await tradeGet(`/api/trade/admin/projects/${projectId}/categories`));
  }

  useEffect(() => { load().catch((requestError) => setError(requestError.message)); }, [projectId]); // eslint-disable-line react-hooks/exhaustive-deps

  async function mutate(action, successMessage) {
    setBusy(true); setError(""); setMessage("");
    try {
      await action();
      await load();
      await onChanged();
      setMessage(successMessage);
      return true;
    } catch (requestError) { setError(requestError.message); return false; }
    finally { setBusy(false); }
  }

  async function create(event) {
    event.preventDefault();
    const created = await mutate(
      () => tradeJson(`/api/trade/admin/projects/${projectId}/categories`, "POST", {
        code: code.trim(), name: name.trim(),
        ...(sortOrder === "" ? {} : { sortOrder: Number(sortOrder) }),
      }),
      "Drawing package added.",
    );
    if (created) { setCode(""); setName(""); setSortOrder(""); }
  }

  function remove(category) {
    if (!window.confirm(`Permanently delete “${category.display_name || `${category.code} ${category.name}`}”? Only an unused category can be deleted.`)) return;
    mutate(
      () => tradeJson(`/api/trade/admin/projects/${projectId}/categories/${category._id}`, "DELETE"),
      "Drawing package deleted.",
    );
  }

  return (
    <div className="trade-modal-backdrop" role="presentation">
      <section className="trade-modal trade-category-manager" role="dialog" aria-modal="true" aria-labelledby="category-manager-title">
        <header><div><span className="trade-eyebrow trade-green">ADMIN</span><h2 id="category-manager-title">Manage drawing packages</h2></div><button aria-label="Close" onClick={onClose}>×</button></header>
        <p className="trade-muted">Add up to ten single-level packages. Rename, reorder, or deactivate a package here. Packages with files or subscribers cannot be permanently deleted.</p>
        {error && <div className="trade-alert error">{error}</div>}
        {message && <div className="trade-alert success">{message}</div>}
        <div className="trade-category-admin-list">
          {categories.map((category) => <CategoryRow key={category._id} category={category} busy={busy} onSave={(id, data) => mutate(() => tradeJson(`/api/trade/admin/projects/${projectId}/categories/${id}`, "PUT", data), "Drawing package updated.")} onDelete={remove} />)}
        </div>
        <form className="trade-category-create" onSubmit={create}>
          <span className="trade-eyebrow">ADD DRAWING PACKAGE</span>
          <label>Code<input value={code} onChange={(event) => setCode(event.target.value)} placeholder="09" required /></label>
          <label>Name<input value={name} onChange={(event) => setName(event.target.value)} placeholder="Specifications" required /></label>
          <label>Order<input type="number" value={sortOrder} onChange={(event) => setSortOrder(event.target.value)} placeholder="9" /></label>
          <button className="trade-button primary" disabled={busy || categories.length >= 10}>Add package</button>
        </form>
        <footer><button className="trade-button secondary" onClick={onClose}>Close</button></footer>
      </section>
    </div>
  );
}
